// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//   apiUrl: 'https://localhost:44386/api'
  // apiUrl: 'https://localhost:44344/api'
      // apiUrl: 'http://10.165.48.20:8071/api' // prod
      //  apiUrl: 'http://hrrequisitionapi.lapapps.ng:8071/api' // prod
   apiUrl: 'https://hrrequisitionapi.lapapps.ng/api' // prod with cert

    //  apiUrl: 'http://10.165.48.27:8071/api'       // Test environment

    //$env:NODE_OPTIONS="--openssl-legacy-provider"; ng s to serve this project
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
